// extracted by mini-css-extract-plugin
export default {"container":"CallStatusBadge_container__copPh","title":"CallStatusBadge_title__70y9+"};